<script setup lang="ts">
import SessionResultEstimatedValue from '@/components/game/session-results/SessionResultEstimatedValue.vue';
import SessionResultStatistics from '@/components/game/session-results/SessionResultStatistics.vue';
import SessionResultVotes from '@/components/game/session-results/SessionResultVotes.vue';
import type { SessionResultsProps, SessionResultValue } from '@/components/game/session-results/types.js';
import { PSeparator } from '@pokerly/ui';

defineProps<SessionResultsProps>();

const emit = defineEmits<{
    confirm: [value: SessionResultValue];
}>();

function onConfirmEstimate(value: SessionResultValue) {
    emit('confirm', value);
}
</script>

<template>
    <section class="flex flex-col gap-6">
        <SessionResultEstimatedValue
            :suggestion="suggestion"
            :estimation-options="estimationOptions"
            @confirm="onConfirmEstimate"
        />
        <SessionResultStatistics
            :mode="mode"
            :median="median"
            :votes-casted="votesCasted"
            :total-voters="totalVoters"
            :mode-voters="modeVoters"
            :has-numeric-votes="hasNumericVotes"
        />
        <PSeparator />
        <SessionResultVotes :chart-data="chartData" :suggestion="suggestion" :mode="mode" />
    </section>
</template>
